import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Form from "./Common_Form";

const Add_User = ({ show, handleClose }) => {
  

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Add New Role
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          <Common_Form handleClose={handleClose}/>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Add_User;
